export default "__VITE_ASSET__6b51bfde__$_?nuxt_component=async__"